import { IProject, IProjectCreate, IProjectUpdate } from '../typing/project.interface';

export class Project {
    data: IProject;

    constructor(data: IProject){
        this.data = data;
    }

    dataForCreate(formData: IProjectCreate): IProjectCreate{
        return {
            name: formData.name,
            // companyId: formData.companyId,
        };
    }

    dataForUpdate(formData: IProjectCreate): IProjectUpdate {
        return {
            id: this.data.id,
            name: formData.name,
            // companyId: formData.companyId,
        };
    }

    formData(): IProjectCreate {
        return {
            name: this.data.name,
            // companyId: this.data.company?.id,
        };
    }
}
